import { render } from "./size.vue?vue&type=template&id=d812e578"
import script from "./size.vue?vue&type=script&lang=js"
export * from "./size.vue?vue&type=script&lang=js"

import exportComponent from "/home/minify-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__